import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerHookUpCSSZSickLeave from './ManagerHookUpCSSZSickLeave';

interface Props extends BaseModalProps {
	onSave: () => void;
}

const ManagerHookUpCSSZSickLeaveModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} title='component.hookUp.csszSickLeave.connection'>
			<ManagerHookUpCSSZSickLeave onSave={props.onSave} />
		</BaseModal>
	);
};

export default ManagerHookUpCSSZSickLeaveModal;
